export default __webpack_public_path__ + "static/media/serviciosAlarma1.a68e6b0a.png";